// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { FiExternalLink } from "react-icons/fi";
import { createPortal } from "react-dom";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveDashboard,
  showVideoPopup,
  showSalesPopUp,
  hideSalesPopUp,
  showNpsPopup,
  setCABannerActive
} from "../../store/auth/action";
import { getSession } from "../../utils/sessionstore";
import { userLogsAPI } from "../../services/session.service";
import CustomContextMenu2 from "./CustomContextMenu2";
import { LockKeyholeIcon } from "../icons";
import { PiDownloadSimpleBold } from "react-icons/pi";
import RailTip from "./RailTip";
import RecordingHoverCard from "./RecordingHoverCard";
import { handleItem } from "../../utils/handleItem";
import amplitude from "../../utils/amplitude/initiate";

const RECORDING_PLACEHOLDER = {
  durationMinutes: 42,
  tags: ["AEP Landscape", "AEP Disruption", "Service Area", "Plan Comparison", "Data Sources", "Filters"],
  description: "How to read landscape shifts and spot disruption before AEP opens.",
  presenterInitials: "KS",
  presenterName: "Kriti Singhania",
  presenterRole: "Product Lead",
  date: "27 Feb 2026",
};

const getInitials = (name) =>
  name
    ?.split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || undefined;

const formatRecordedDate = (value) => {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return date.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
};

const buildRecordingCardProps = (dashboard) => {
  const hasTags = Array.isArray(dashboard?.tags) && dashboard.tags.length > 0;

  return {
    durationMinutes: dashboard?.durationSeconds
      ? Math.round(dashboard.durationSeconds / 60)
      : RECORDING_PLACEHOLDER.durationMinutes,
    tags: hasTags ? dashboard.tags : RECORDING_PLACEHOLDER.tags,
    description: dashboard?.description?.trim() || RECORDING_PLACEHOLDER.description,
    presenterName: dashboard?.presenterName?.trim() || RECORDING_PLACEHOLDER.presenterName,
    presenterRole: dashboard?.presenterRole?.trim() || RECORDING_PLACEHOLDER.presenterRole,
    presenterInitials:
      getInitials(dashboard?.presenterName) || RECORDING_PLACEHOLDER.presenterInitials,
    date: formatRecordedDate(dashboard?.recordedDate) || RECORDING_PLACEHOLDER.date,
  };
};

const RecordingHoverAnchor = ({ label, dashboard, onClick, className }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState(null);
  const rowRectRef = useRef(null);
  const cardRef = useRef(null);

  const handleEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    rowRectRef.current = rect;
    const container = e.currentTarget.closest(".dashboard-flyout") || e.currentTarget.closest(".sidebar");
    const containerRight = container ? container.getBoundingClientRect().right : rect.right;
    setCoords({ top: rect.top, left: Math.max(rect.right, containerRight) + 8, arrowTop: rect.height / 2 });
    setVisible(true);
  };

  useLayoutEffect(() => {
    if (!visible || !coords || !cardRef.current || !rowRectRef.current) return;
    const cardHeight = cardRef.current.offsetHeight;
    const margin = 8;
    const maxTop = window.innerHeight - cardHeight - margin;
    const clampedTop = Math.min(coords.top, Math.max(margin, maxTop));
    const rowCenter = rowRectRef.current.top + rowRectRef.current.height / 2;
    const arrowTop = Math.min(cardHeight - 16, Math.max(16, rowCenter - clampedTop));

    if (clampedTop !== coords.top || arrowTop !== coords.arrowTop) {
      setCoords((prev) => (prev ? { ...prev, top: clampedTop, arrowTop } : prev));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, coords?.left]);

  return (
    <div
      className={className}
      onClick={onClick}
      onMouseEnter={handleEnter}
      onMouseLeave={() => setVisible(false)}
    >
      {label}
      {visible &&
        coords &&
        createPortal(
          <div ref={cardRef} className="fixed z-[9999]" style={{ top: coords.top, left: coords.left }}>
            <RecordingHoverCard title={label} arrowTop={coords.arrowTop} {...buildRecordingCardProps(dashboard)} />
          </div>,
          document.body
        )}
    </div>
  );
};
const NewDashboardBox = ({ dashboard, afterlandDashboardNew,view=false, hover=false, indentClass="px-3", categoryLabel, rowClassName="self-stretch h-8 hover:bg-general-accent ani flex justify-start items-center gap-2", trailingIcon=null }) => {
  const { clientID } = useParams();
  const currentURL = window.location.origin;
  const [tooltipVisibility, setTooltipVisible] = useState(false);
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    subscriptions,
    newTabClickObject,
    userDetails,
    clientname,
    rightClickOptionPosition,
    isWebinarPopActive,
    isNpsPopActive
  } = useSelector((state) => ({
    subscriptions: state.subscriptions,
    newTabClickObject: state.newTabClickObject,
    clientname: state.clientname,
    userDetails: state.userDetails,
    rightClickOptionPosition: state.rightClickOptionPosition,
    isWebinarPopActive: state.isWebinarPopActive,
    isNpsPopActive: state.isNpsPopActive
  }));
  const activedashboard = useSelector((state) => state.activedashboard);
  const isActive = activedashboard?._id === dashboard?._id;
  const contextMenuRef2 = useRef(null);
  const [contextMenuVisible2, setContextMenuVisible2] = useState(false);
  const sessionId = getSession("session_id");

  async function callUserLogAPI(
    place,
    dashboardName,
    standardName,
    dashboardId,
    clickType
  ) {
    try {
      const logresponse = userLogsAPI(
        place,
        standardName,
        userDetails,
        clientname,
        dashboardName,
        clickType,
        getSession("client_id"),
        dashboardId
      );
      // console.log(logresponse, "banner click");
    } catch (err) {
      console.log(err.message);
    }
  }

  async function landDashboardNew(activedashboard) {
    if (!subscriptions?.length || !activedashboard?.standarddashboardId?._id) return;
  
    const targetId = activedashboard?.standarddashboardId?._id;
    let localProductLine = "";
  
    for (const subscription of subscriptions) {
      const categories = subscription.productcategoryIds || [];
  
      for (const category of categories) {
        const dashboards = category.dashboardIds || [];
  
        const match = dashboards.find(
          dash => dash.standarddashboardId?._id === targetId
        );
  
        if (match) {
          localProductLine = subscription.label;
          break;
        }
      }
  
      if (localProductLine) break; // Exit outer loop once match is found
    }
    await handleItem({productLine:localProductLine, clientID: clientID ?? getSession("client_id"), userDetails: userDetails, dashboard: activedashboard, clientName: clientname, triggerType: "SIDEBAR_DASHBOARD", pathname: location.pathname, postItemHandle: afterlandDashboardNew, dispatch: dispatch, navigate: navigate,staticPop:isWebinarPopActive, categoryLabel });

    setTimeout(() => {
      if(["Organization Snapshot"].includes(activedashboard?.standarddashboardId?.standardName)) dispatch(setCABannerActive(true));
    }, 1000);
  }

  const handleTooltipClick = async () => {
    setContextMenuVisible2(false);
    if (!subscriptions?.length || !dashboard?.standarddashboardId?._id) return;
  
    const targetId = dashboard?.standarddashboardId?._id;
    let localProductLine = "";
  
    for (const subscription of subscriptions) {
      const categories = subscription.productcategoryIds || [];
  
      for (const category of categories) {
        const dashboards = category.dashboardIds || [];
  
        const match = dashboards.find(
          dash => dash.standarddashboardId?._id === targetId
        );
  
        if (match) {
          localProductLine = subscription.label;
          break;
        }
      }
  
      if (localProductLine) break; // Exit outer loop once match is found
    }
    await handleItem({productLine:localProductLine, clientID: clientID ?? getSession("client_id"), userDetails: userDetails, dashboard: dashboard, clientName: clientname, triggerType: "NEWTAB_SIDEBAR_DASHBOARD", pathname: location.pathname, postItemHandle: afterlandDashboardNew, dispatch: dispatch, navigate: navigate });
  };

  const [rcPosition, setRcPosition] = useState({});

  const handleContextMenu = (e) => {
    setRcPosition({ x: e.clientX, y: e.clientY });
    e.preventDefault();
    setContextMenuVisible2(true);
  };

  const handleClickOutside = (event) => {
    if (parentref.current && !parentref.current.contains(event.target)) {
      setContextMenuVisible2(false);
    }
  };

  function replaceImageSrc(originalSrc) {
    // Use the replace method to replace "_h-16." with "_h-13-dark."
    if (originalSrc) {
      var newSrc = originalSrc.replace("_h-16.", "_h-13-dark.");
      var newSrc2 = newSrc.replace("tags", "images");

      return newSrc2;
    }
    return originalSrc;
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("contextmenu", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.addEventListener("contextmenu", handleClickOutside);
    };
  }, []);
  const parentref = useRef(null);

  return (
      <>
        {view ? (
          // ---- MODIFIED BLOCK FOR view === true ----
          <div className="self-stretch flex flex-col items-start">
            <div
              onMouseLeave={() => setContextMenuVisible2(false)}
              ref={parentref}
              onContextMenu={handleContextMenu}
              key={dashboard?._id}
              className={`font-geist ${isActive ? rowClassName.replace("hover:bg-general-accent", "bg-general-secondary") : rowClassName} ${indentClass}`}
            >
              {contextMenuVisible2 &&
                dashboard?.type !== "video" &&
                dashboard?.url !== "Disabled" &&
                dashboard?.url !== "Greyed" && (
                  <div>
                    <CustomContextMenu2
                      position={rcPosition}
                      label="Open in New Tab"
                      func={handleTooltipClick}
                    />
                  </div>
                )}
    
              {/* Recording hover-preview card disabled for now - flip `false &&` back off to re-enable */}
              {false && dashboard?.type?.trim() === "video" ? (
                <RecordingHoverAnchor
                  label={dashboard?.label}
                  dashboard={dashboard}
                  onClick={() => landDashboardNew(dashboard)}
                  className="flex-1 min-w-0 flex justify-start items-center gap-1.5 text-general-foreground cursor-pointer truncate text-sm font-normal leading-5 text-left"
                />
              ) : (
              <RailTip
                title={
                  dashboard?.hoverText?.trim() &&
                  dashboard?.url?.trim() === "Greyed"
                    ? dashboard?.hoverText?.trim()
                    : dashboard?.label
                }
                whenTruncated={
                  !(
                    dashboard?.hoverText?.trim() &&
                    dashboard?.url?.trim() === "Greyed"
                  )
                }
              >
                <div
                  onClick={() => {
                    landDashboardNew(dashboard);
                  }}
                  className={`flex-1 min-w-0 truncate text-sm font-normal leading-5 text-left ${
                    dashboard?.url?.trim() === "Greyed"
                      ? "text-general-muted-foreground cursor-default"
                      : "text-general-foreground cursor-pointer"
                  }`}
                >
                  {dashboard?.label}
                </div>
              </RailTip>
              )}

              {dashboard?.type?.trim() === "Open in new tab" && (
                <span className="size-4 shrink-0 relative overflow-hidden text-general-muted-foreground hover:text-general-foreground ani">
                  <FiExternalLink className="size-3.5 left-[1px] top-[1px] absolute" />
                </span>
              )}

              {dashboard?.type?.trim() === "Download" && (
                <PiDownloadSimpleBold className="size-3.5 shrink-0 text-general-muted-foreground" />
              )}

              {dashboard?.tagimg && (
                <img
                  className="h-5 shrink-0 cursor-pointer"
                  alt="tag"
                  src={replaceImageSrc(dashboard?.tagimg)}
                />
              )}

              {dashboard?.url?.trim() === "Disabled" && (
                <LockKeyholeIcon className="size-3.5 shrink-0 text-[#e07575]" />
              )}

              {trailingIcon &&
                dashboard?.url?.trim() !== "Disabled" &&
                dashboard?.url?.trim() !== "Greyed" && (
                  <span className="w-5 p-0.5 shrink-0 flex flex-col justify-center items-center">
                    {trailingIcon}
                  </span>
                )}
            </div>
          </div>
        ) : (
          // ---- ORIGINAL BLOCK FOR view === false ----
          <div
            onMouseLeave={() => setContextMenuVisible2(false)}
            ref={parentref}
            onContextMenu={handleContextMenu}
            key={dashboard?._id}
            className={`font-geist self-stretch h-8 px-3 ${isActive ? "bg-general-secondary" : "hover:bg-general-accent"} ani flex flex-nowrap justify-start items-center gap-2`}
          >
            {contextMenuVisible2 &&
              dashboard?.type !== "video" &&
              dashboard?.url !== "Disabled" &&
              dashboard?.url !== "Greyed" && (
                <div>
                  <CustomContextMenu2
                    position={rcPosition}
                    label="Open in New Tab"
                    func={handleTooltipClick}
                  />
                </div>
              )}
    
            {/* Recording hover-preview card disabled for now - flip `false &&` back off to re-enable */}
            {false && dashboard?.type?.trim() === "video" ? (
              <RecordingHoverAnchor
                label={dashboard?.label}
                dashboard={dashboard}
                onClick={() => landDashboardNew(dashboard)}
                className="flex-1 min-w-0 truncate text-left text-sm font-normal leading-5 text-general-foreground cursor-pointer"
              />
            ) : (
            <RailTip
              title={
                dashboard?.hoverText?.trim() &&
                dashboard?.url?.trim() === "Greyed"
                  ? dashboard?.hoverText?.trim()
                  : dashboard?.label
              }
              whenTruncated={
                !(
                  dashboard?.hoverText?.trim() &&
                  dashboard?.url?.trim() === "Greyed"
                )
              }
            >
              <div
                onClick={() => {
                  landDashboardNew(dashboard);
                }}
                className={`flex-1 min-w-0 truncate text-left text-sm font-normal leading-5 ${
                  dashboard?.url?.trim() === "Greyed"
                    ? "text-general-muted-foreground cursor-default"
                    : "text-general-foreground cursor-pointer"
                }`}
              >
                {dashboard?.label}
              </div>
            </RailTip>
            )}

            {dashboard?.type?.trim() === "Open in new tab" ? (
              <span className="size-4 shrink-0 relative overflow-hidden text-general-muted-foreground hover:text-general-foreground ani">
                <FiExternalLink className="size-3.5 left-[1px] top-[1px] absolute cursor-pointer" />
              </span>
            ) : null}

            {dashboard?.type?.trim() === "Download" ? (
              <PiDownloadSimpleBold className="size-3.5 shrink-0 text-general-muted-foreground cursor-pointer" />
            ) : null}

            {dashboard?.tagimg && (
              <img
                className="h-5 shrink-0 cursor-pointer"
                alt="tag"
                src={replaceImageSrc(dashboard?.tagimg)}
              />
            )}

            {dashboard?.url?.trim() === "Disabled" ? (
              <LockKeyholeIcon className="size-3.5 shrink-0 text-[#e07575]" />
            ) : null}
          </div>
        )}
      </>
    );
};

export default NewDashboardBox;
